import { TApplicationState } from '../../types/redux';
import { getUrlPath } from '../path';

export const mortgageSeoPageUrlSelector = (state: TApplicationState): string => {
  const fullPath = getUrlPath(state);

  return `${fullPath}ipoteka-zhk/`;
};
